const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/initialValues.ts';
import { useSelector } from 'react-redux';
import { useCaseData } from 'App/store/case';
import { selectUserDetailsFromRegisterWorkItem } from 'App/store/login';
import { usePatientData } from 'App/store/patient';
import { getArztDataFromCase } from 'App/utils/cases';
import { normalizePhoneNumber } from 'App/utils/phoneNumberUtils';

export const useECheckinInitialValues = (fallNr?: string) => {
    const [pat, patientIsLoading] = usePatientData();
    const loginDetails = useSelector(selectUserDetailsFromRegisterWorkItem);

    const [caseData, caseDataIsLoading] = fallNr ? useCaseData(fallNr) : [undefined, false];
    const hausArztData = getArztDataFromCase(caseData, 'HausAz');

    const isLoading = patientIsLoading || caseDataIsLoading;

    const persAngaben = {
        firstname: pat.get('VORNAME') ?? loginDetails?.get('firstname') ?? '',
        lastname: pat.get('NAME') ?? loginDetails?.get('lastname') ?? '',
        streetAndNumber: pat.get('STRASSE') ?? '',
        plz: pat.get('PLZ') ?? '',
        ort: pat.get('ORT') ?? '',
        country: pat.get('LAND') ?? '',
        geschlecht: pat.get('SEX') ?? '',
        dateOfBirth: (pat.get('GEBDAT') || '').slice(0, 10), // YYYY-MM-DD
        tel: normalizePhoneNumber(pat.get('TELEFON') || pat.get('TELEFON_G')),
        mobile: normalizePhoneNumber(pat.get('TELEFON_M') || loginDetails?.get('mobile')),
        nationality: pat.get('NATIONALITAET') ?? '',
        zivilstatus: pat.get('ZIVILSTAND') ?? '',
        lang: pat.get('SPRACHE') ?? '',
        ahv: pat.get('SOZVERSNR') ?? '',
        religion: pat.get('KONFESSION') ?? '',
        profession: pat.get('BERUF') ?? '',
        email: (loginDetails?.get('email') || pat.get('EMAIL')) ?? '',
    };
    const einwArzt = hausArztData
        ? {
              firstname: hausArztData.Vorname,
              lastname: hausArztData.Name,
              streetAndNumber: hausArztData.Strasse,
              ort: hausArztData.Ort,
              plz: hausArztData.PLZ,
              country: hausArztData.Land,
              tel: normalizePhoneNumber(hausArztData?.Tel),
              key: hausArztData.OBJECTKEY,
          }
        : {};

    return [{ persAngaben, einwArzt }, isLoading];
};
